import { IExperience, ILanguage } from 'pages/About/About.types';
import http from 'services/httpService';
import { IAboutDataResponse } from 'types/api-responses';
import { IApiRoutes } from 'types/api-routes';

const getBioData = () =>
  Promise.resolve(
    http.get<string>(`${process.env.REACT_APP_PORTFOLIO_API}/${IApiRoutes.Bio}`)
  );
const getExperienceData = () =>
  Promise.resolve(
    http.get<IExperience[]>(
      `${process.env.REACT_APP_PORTFOLIO_API}/${IApiRoutes.Experience}`
    )
  );
const getEducationData = () =>
  Promise.resolve(
    http.get<IExperience[]>(
      `${process.env.REACT_APP_PORTFOLIO_API}/${IApiRoutes.Education}`
    )
  );
const getLanguagesData = () =>
  Promise.resolve(
    http.get<ILanguage[]>(
      `${process.env.REACT_APP_PORTFOLIO_API}/${IApiRoutes.Languages}`
    )
  );
const getSkillsData = () =>
  Promise.resolve(
    http.get<string[]>(
      `${process.env.REACT_APP_PORTFOLIO_API}/${IApiRoutes.Skills}`
    )
  );

export const getAboutData = (): Promise<IAboutDataResponse> => {
  const bio = getBioData();
  const experience = getExperienceData();
  const education = getEducationData();
  const languages = getLanguagesData();
  const skills = getSkillsData();

  return Promise.all([bio, experience, education, languages, skills])
    .then((data) => {
      const [response1, response2, response3, response4, response5] = data;
      return {
        data: {
          bio: response1.data,
          experience: response2.data,
          education: response3.data,
          languages: response4.data,
          skills: response5.data,
        },
      };
    })
    .catch((err) => err);
};
